import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

const initialState = {
  selectedClient: { label: "Cyberior", value: "cyberior" },
  selectedClientRecord: null,
  clients: [],
  count: 0,
  clientsDetail: {},
  tenantsData:[],
  allCountries:[],
  masterAddOns:[]
};

export const getAllClients = createAsyncThunk(
  "Clients/getAllClients",
  async (payload) => {
    try {
      const response = await api.clients.getAllClients(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const getAllTenants = createAsyncThunk(
  "Clients/getAllTenants",
  async (payload) => {
    try {
      const response = await api.clients.getAllTenants(payload);
      console.log(response,"RESSSS");
      
      if (response.status === 201 || response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createClient = createAsyncThunk(
  "Clients/createClients",
  async (payload) => {
    try {
      const response = await api.clients.createClients(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const updateClients = createAsyncThunk(
  "Clients/updateClients",
  async ({ id, payload }) => {
    try {
      const response = await api.clients.updateClients(id, payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const deleteClients = createAsyncThunk(
  "Clients/deleteClients",
  async ({ id, payload }) => {
    try {
      const response = await api.clients.deleteClients(id, payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const getAllCountries = createAsyncThunk(
  "Clients/getAllCountries",
  async (payload) => {
    try {
      const response = await api.clients.getAllCountries(payload);
      if (response.status === 200 ||response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const getAddOnMaster = createAsyncThunk(
  "Clients/getAddOnMaster",
  async (payload) => {
    try {
      const response = await api.clients.getAddOnMaster(payload);
      if (response.status === 200 ||response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createAddOnMaster = createAsyncThunk(
  "Clients/createAddOnMaster",
  async (payload) => {
    try {
      const response = await api.clients.createAddOnMaster(payload);
      if (response.status === 201 || response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const updateAddOnMaster = createAsyncThunk(
  "Clients/updateAddOnMaster",
  async ({ id, payload }) => {
    try {
      const response = await api.clients.updateAddOnMaster(id, payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const deleteAddOnMaster = createAsyncThunk(
  "Clients/deleteAddOnMaster",
  async ({ id }) => {
    try {
      const response = await api.clients.deleteAddOnMaster(id);
      if (response.status === 200) {
        return { id, data: response.data };
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

const clientsSlice = createSlice({
  name: "clientsSliceData",
  initialState,
  reducers: {
    setClient: (state, action) => {
      console.log(action, "assign state");
      state.selectedClient = action.payload;
      // Reset selected client record when tenant changes
      state.selectedClientRecord = null;
    },
    setClientRecord: (state, action) => {
      state.selectedClientRecord = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllClients.pending, (state) => {
        console.log("Fetching clients...");
      })
      .addCase(getAllClients.fulfilled, (state, action) => {
        console.log("Clients fetched successfully:", action.payload);
        state.clients = action.payload?.clients ?? (Array.isArray(action.payload) ? action.payload : []);
        state.count = action.payload?.count ?? state.clients.length;
      })
      .addCase(getAllClients.rejected, (state, action) => {
        state.clients = [];
        state.count = 0;
        console.log("Failed to fetch clients:", action.error.message);
      }) 
      .addCase(createClient.fulfilled, (state, action) => {
        console.log("Client created successfully", action.payload);
        // Add the new client to the array
        if (Array.isArray(state.clients)) {
          state.clients.push(action.payload);
        } else {
          state.clients = [action.payload];
        }
      })
      .addCase(createClient.pending, (state) => {
        console.log("Creating client...");
      })
      .addCase(createClient.rejected, (state, action) => {
        console.error("Failed to create client", action.error.message);
        // Handle error state if needed
      })
      .addCase(getAllTenants.pending, (state) => {
        console.log("pending");
      })
      .addCase(getAllTenants.fulfilled, (state, action) => {
        // console.log(state,action,"getAllTenants");
        state.tenantsData = action.payload;
      })
      .addCase(getAllTenants.rejected, (state, action) => {
        state.tenantsData = [];    
        console.log("rejected", action.error.message);
      }) 
      .addCase(getAllCountries.pending, (state) => {
        console.log("Fetching Countries...");
      })
      .addCase(getAllCountries.fulfilled, (state, action) => {
        console.log("Countries fetched successfully:", action.payload);
        state.allCountries = action.payload?.countries ;
      })
      .addCase(getAllCountries.rejected, (state, action) => {
        console.log("Failed to fetch clients:", action.error.message);
      })

      .addCase(getAddOnMaster.pending, (state) => {
        console.log("Fetching Countries...");
      })
      .addCase(getAddOnMaster.fulfilled, (state, action) => {
        console.log("Countries fetched successfully:", action.payload);
        state.masterAddOns = action.payload;
      })
      .addCase(getAddOnMaster.rejected, (state, action) => {
        console.log("Failed to fetch clients:", action.error.message);
      })

      .addCase(createAddOnMaster.fulfilled, (state, action) => {
        if (Array.isArray(state.masterAddOns)) {
          state.masterAddOns.push(action.payload);
        } else {
          state.masterAddOns = [action.payload];
        }
      })
      .addCase(createAddOnMaster.rejected, (state, action) => {
        console.error("Failed to create add-on service", action.error.message);
      })

      .addCase(updateAddOnMaster.fulfilled, (state, action) => {
        const updated = action.payload;
        state.masterAddOns = (state.masterAddOns || []).map((item) =>
          item.ID === updated?.ID ? updated : item
        );
      })
      .addCase(updateAddOnMaster.rejected, (state, action) => {
        console.error("Failed to update add-on service", action.error.message);
      })

      .addCase(deleteAddOnMaster.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.masterAddOns = (state.masterAddOns || []).filter(
          (item) => item.ID !== id
        );
      })
      .addCase(deleteAddOnMaster.rejected, (state, action) => {
        console.error("Failed to delete add-on service", action.error.message);
      });

  },
});

export const { setClient, setClientRecord } = clientsSlice.actions;

export default clientsSlice.reducer;
